export default __webpack_public_path__ + "static/img/product_image.e3265fd.png";